module.exports = __webpack_public_path__ + "img/spotify-512.2af487f3.png";